// eslint-disable-next-line no-restricted-imports
import {
  default as Button,
  type ButtonProps as AntButtonProps
} from 'antd/es/button';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

export const SecondaryButton = forwardRef<HTMLButtonElement, AntButtonProps>(
  ({ ...props }, ref: ForwardedRef<HTMLButtonElement>) => {
    return <Button type="default" ref={ref} {...props} />;
  }
);

SecondaryButton.displayName = 'SecondaryButton';
